/**
 * Umami-events (självhostad, cookiefri). Skriptet i public/index.html spårar
 * bara på harrydabbq.se via data-domains, så anrop på staging/localhost är
 * no-ops i Umami. Skicka aldrig personuppgifter – bara steg, antal och summor.
 */
export const trackUmami = (eventName, data) => {
  if (typeof window === 'undefined') return false;
  const umami = window.umami;
  if (!umami || typeof umami.track !== 'function') return false;
  try {
    if (data && Object.keys(data).length > 0) umami.track(eventName, data);
    else umami.track(eventName);
    return true;
  } catch {
    return false;
  }
};
